import { FC, useCallback, useContext, useRef } from 'react';
import { observer } from "mobx-react-lite";
import DocumentCopy from '../../../assets/document-copy.svg';
import { AppContext } from '../../../App';
import Tooltip from "../../UiLib/CustomTooltip/CustomTooltip";

export interface ICopyButtonProps {
    textDivId: string;
    title?: string;
    titlePosition?: "top" | "left" | "right" | "bottom";
    text?: string
}

const BtnCopyText: FC<ICopyButtonProps> = observer(({
    textDivId,
    title,
    titlePosition = "top",
    text
}) => {
    const { showToast } = useContext(AppContext);
    const timeoutRef = useRef<NodeJS.Timeout>();

    const onClick = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        if (!text) {
            const element = document.getElementById(textDivId);
            text = element?.textContent?.trim();
        }
        if (!text) {
            showToast("Нечего копировать");
            return;
        }

        navigator.clipboard.writeText(text).then(() => {
            showToast("Скопировано в буфер обмена");
        }).catch((error) => {
            console.error('Ошибка копирования:', error);
            showToast("Не удалось скопировать");

            try {
                const textArea = document.createElement('textarea');
                textArea.value = text!;
                document.body.appendChild(textArea);
                textArea.select();
                document.body.removeChild(textArea);
                showToast("Скопировано в буфер обмена");
            } catch (fallbackError) {
                showToast("Ошибка при копировании");
            }
        });

        timeoutRef.current = setTimeout(() => {
            timeoutRef.current = undefined;
        }, 1000);

    }, [textDivId, showToast]);

    return (
        <Tooltip
            text={title ?? ""}
            placement={titlePosition}
            offset={3}
        >
            <button
                type="button"
                className="button_copy button-base"
                onClick={onClick}
                aria-label={title || "Копировать текст"}
            >
                <img
                    src={DocumentCopy}
                    alt="Копировать"
                    width={16}
                    height={16}
                />
            </button>
        </Tooltip>
    );
});

export default BtnCopyText;